import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

/**
 * Banda gris compacta entre el ContextBanner y el grid de cards.
 * Muestra el resumen global antes de que Cindy baje a las tarjetas:
 *   - N de M pagos incluidos.
 *   - Ordinales ya cubiertos en la matrícula (los tachados en el picker).
 *   - Total de materias del programa.
 *
 * Solo aparece cuando hay 1 matrícula (semester-based) y hay claimed
 * ordinals o counts a mostrar. En multi-matrícula el conteo por matrícula
 * varía y se vuelve ruidoso.
 */
export default function SummaryBar({
  includedCount,
  totalCount,
  claimedOrdinalsList,
  subjectsTotal,
  visible,
}) {
  if (!visible) return null;

  // Aceptamos claimedOrdinalsList tanto como number[] (legacy) como {ord, source}[]
  const normalized = Array.isArray(claimedOrdinalsList)
    ? claimedOrdinalsList.map((it) => (typeof it === 'object' ? it : { ord: it, source: 'payment' }))
    : [];
  const byPayment = normalized.filter((it) => it.source !== 'manual').map((it) => it.ord).sort((a, b) => a - b);
  const manual = normalized.filter((it) => it.source === 'manual').map((it) => it.ord).sort((a, b) => a - b);
  const hasClaimed = normalized.length > 0;

  return (
    <Box bg="gray.50" borderBottomWidth="1px" borderColor="gray.100" px={6} py={2.5}>
      <Flex align="center" justify="space-between" gap={3} flexWrap="wrap">
        <Text fontSize="12px" color="gray.700">
          <strong>{includedCount} de {totalCount}</strong> pago{totalCount === 1 ? '' : 's'} incluido{totalCount === 1 ? '' : 's'}
        </Text>
        {(hasClaimed || subjectsTotal > 0) && (
          <Flex align="center" gap={4} fontSize="12px" color="gray.600" flexWrap="wrap">
            {byPayment.length > 0 && (
              <Text>
                Cubiertas por pago:{' '}
                <Text as="span" fontWeight="600" color="#5B21B6">{byPayment.join(', ')}</Text>
              </Text>
            )}
            {manual.length > 0 && (
              <Text>
                Ajuste manual:{' '}
                <Text as="span" fontWeight="600" color="#B45309">{manual.join(', ')}</Text>
              </Text>
            )}
            {subjectsTotal > 0 && (
              <Text>
                Total del programa: <Text as="span" fontWeight="600" color="gray.700">{subjectsTotal}</Text>
              </Text>
            )}
          </Flex>
        )}
      </Flex>
    </Box>
  );
}
